import { render } from "./ItemPage.vue?vue&type=template&id=6f7297dc&scoped=true"
import script from "./ItemPage.vue?vue&type=script&lang=js"
export * from "./ItemPage.vue?vue&type=script&lang=js"

import "./ItemPage.vue?vue&type=style&index=0&id=6f7297dc&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7297dc"]])

export default __exports__